var map = {
	"./abcesses.png": 40411,
	"./bleeding-gums.png": 7710,
	"./cracked-tooth.png": 3915,
	"./dent-issue.png": 85425,
	"./filling-issue.png": 95883,
	"./imp-issues.png": 40343,
	"./swelling.png": 3357,
	"./tooth-ache.png": 20988,
	"./ulcer_new.jpg": 91809,
	"./ulcers.png": 78239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8908;